import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface WelcomeDialogProps {
  cities: string[];
  onComplete: (name: string, city: string) => void;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const WelcomeDialog = ({ cities, onComplete, open: controlledOpen, onOpenChange }: WelcomeDialogProps) => {
  const [name, setName] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const open = controlledOpen !== undefined ? controlledOpen : false;

  useEffect(() => {
    const savedName = localStorage.getItem("napihami_username");
    const savedCity = localStorage.getItem("napihami_city");
    
    if (savedName) setName(savedName);
    if (savedCity) setSelectedCity(savedCity);
  }, []);

  const handleSubmit = () => {
    if (name && selectedCity) {
      onComplete(name, selectedCity);
      setName("");
      setSelectedCity("");
    }
  };

  const handleClose = () => {
    // Use default values when closing without providing data
    const defaultName = "Anonymous";
    const defaultCity = "Dunaújváros";
    onComplete(name || defaultName, selectedCity || defaultCity);
    setName("");
    setSelectedCity("");
  };

  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      handleClose();
    }
    if (onOpenChange) {
      onOpenChange(newOpen);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent 
        className="sm:max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Üdvözlünk a NapiHami oldalon!</DialogTitle>
          <DialogDescription>
            Hogy szólíthatunk és melyik város ételeit szeretnéd látni?
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="name">Hogyan szólíthatunk?</Label>
            <Input
              id="name"
              placeholder="Ide írd a megszólításod"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="city">Város</Label>
            <Select value={selectedCity} onValueChange={setSelectedCity}>
              <SelectTrigger id="city">
                <SelectValue placeholder="Válassz várost" />
              </SelectTrigger>
              <SelectContent>
                {cities.map((city) => (
                  <SelectItem key={city} value={city}>
                    {city}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <Button onClick={handleSubmit} className="w-full" disabled={!name || !selectedCity}>
            Tovább
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
